import { createSlice } from '@reduxjs/toolkit';
import { getDataFromLocalStorage, localStorageData, setDataToLocalStorage } from '../../services/localStorage';

const userFromLocalStorage = getDataFromLocalStorage(localStorageData.user);

const initialauthState = {
  user: userFromLocalStorage || null,
  isLoggedIn: userFromLocalStorage ? true : false,
  Error: null,
  isLoaded: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialauthState,
  reducers: {
    onInitialAuth(state, action) {
      state.user = action.payload;
      state.isLoggedIn = true;
      state.isLoaded = true;
      state.Error = null;
    },

    onSetError(state, action) {
      state.user = null;
      state.isLoggedIn = false;
      state.Error = action.payload;
      state.isLoaded = true;
    },

    onSetLoaded(state, action) {
      state.isLoaded = action.payload;
    },

    onLocalLogout(state, action) {
      setDataToLocalStorage(localStorageData.isShowMessageAuth, 0);
      localStorage.removeItem(localStorageData.user);
      state.user = null;
      state.isLoggedIn = false;
      state.Error = null;
      state.isLoaded = true;
    }
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;